import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'

import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

const ERROR_MESSAGE =
  'システムでエラーが発生しました。再試行しても問題が解決しない場合はサポートチームにご連絡ください。'

/**
 * true を設定したリクエストは共通のシステムエラー snackbar を出さない。
 * 呼び出し側がサーバーのエラーメッセージを独自に表示する場合に使う。
 */
export const SKIP_GENERIC_ERROR_SNACKBAR = new HttpContextToken<boolean>(
  () => false,
)

@Injectable()
export class NoopInterceptor implements HttpInterceptor {
  constructor(private snackBar: MatSnackBar) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (res) => {
          if (req.context.get(SKIP_GENERIC_ERROR_SNACKBAR)) {
            return
          }
          if (
            'body' in res &&
            res.body != null &&
            typeof res.body === 'object' &&
            'errors' in res.body
          ) {
            this.snackBar.open(ERROR_MESSAGE, 'x', {
              duration: 3000,
              panelClass: ['default-snackbar'],
            })
          }
        },
        (error) => {
          // 401 は認証切れのため共通のシステムエラー表示は出さない
          if (error.status === 401) {
            return
          }
          // 呼び出し側が独自にエラー表示するリクエストは対象外
          if (req.context.get(SKIP_GENERIC_ERROR_SNACKBAR)) {
            return
          }
          this.snackBar.open(ERROR_MESSAGE, 'x', {
            duration: 3000,
            panelClass: ['default-snackbar'],
          })
        },
      ),
    )
  }
}
